import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { firstValueFrom } from 'rxjs';
// import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
import {
  DxDataGridModule,
  DxButtonModule, DxTreeListModule, DxGalleryModule, DxAutocompleteModule, DxHtmlEditorModule, DxToolbarModule,
  DxPopoverModule, DxPopupModule, DxTemplateModule, DxTabPanelModule, DxFormModule, DxRadioGroupModule, DxAccordionModule, DxSpeedDialActionModule, DxLoadPanelModule,
  DxSelectBoxModule, DxDataGridComponent, DxRangeSliderModule, DxNumberBoxModule, DxAccordionComponent, DxScrollViewModule
  , DxCheckBoxModule, DxSwitchModule
} from 'devextreme-angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { OrgchartModule } from '@dabeng/ng-orgchart';
import { ManagerApprovalModalComponent } from './manager-approval-modal/manager-approval-modal.component';
import { OrganizationChartModule } from 'primeng/organizationchart';

import { ColorPickerModule } from 'ngx-color-picker';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { TabsModule } from 'primeng/tabs';
//Components
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { AgencyMasterComponent } from './agencyMaster/agency-master.component';
import { AgencyBranchChartComponent } from './agencyBranchChart/agency-branch-chart.component';
import { UsersComponent } from './users/users.component';
import { LoginComponent } from './login/login.component';
import { BranchInformationComponent } from './branchInformation/branch-information.component';
import { BranchListComponent } from './branchList/branch-list.component';
import { AgencyRightsComponent } from './agencyRights/agency-rights.component';
import { AgencyListComponent } from './agencyList/agency-list.component';
import { UserListComponent } from './userList/user-list.component';
import { SuppliersListComponent } from './suppliersList/suppliers-list.component';
import { SuppliersAddEditComponent } from './suppliersAddEdit/suppliers-add-edit.component';
import { CMSComponent } from './cms/cms.component';
import { CmsSubHeaderComponent } from './cms-sub-header/cms-sub-header.component';
import { CmsSubLandingComponent } from './cms-sub-landing/cms-sub-landing.component';
import { CmsSubDealsComponent } from './cms-sub-deals/cms-sub-deals.component';
import { CmsSubFSitemapComponent } from './cms-sub-fsitemap/cms-sub-fsitemap.component';
import { CmsSubFSocialComponent } from './cms-sub-fsocial/cms-sub-fsocial.component';
import { CmsSubFContactsComponent } from './cms-sub-fcontacts/cms-sub-fcontacts.component';
import { ContactUsComponent } from './contactus/contactus.component';
import { AboutUsComponent } from './aboutus/aboutus.component';
import { CmsSubContactUsComponent } from './cms-sub-contactus/cms-sub-contactus.component';
import { CmsAboutUsLandingComponent } from './cms-aboutuslanding/cms-aboutuslanding.component';
import { CmsAboutUsServicesComponent } from '././cms-aboutusservices/cms-aboutusservices.component';
import { CmsLogoComponent } from './cms-logo/cms-logo.component';
import { CmsAboutUsTimelineComponent } from './cms-aboutustimeline/cms-aboutustimeline.component';
import { RevenueManagementComponent } from './revenueManagement/revenue-management.component';
import { AgencySupplierRightsComponent } from './agencySupplierRights/agency-supplier-rights.component';
import { BeneficiaryAccountComponent } from './beneficiary-account/beneficiary-account.component';
import { BeneficiaryAccountsAllocationComponent } from './beneficiary-accounts-allocation/beneficiary-accounts-allocation.component';
import { CreateBeneficiaryAccountComponent } from './create-beneficiary-account/create-beneficiary-account.component';
import { RevenueManagementListComponent } from './revenueManagementList/revenue-management-list.component';
import { Agency_BranchGroupsComponent } from './agency_BranchGroups/agency_branch-groups.component';
import { Agency_BranchGroupListComponent } from './agency_BranchGroupList/agency_branch-group-list.component';
import { FlightSearchComponent } from './flightSearch/flight-search.component';
import { PaymentAddEditComponent } from './paymentAddEdit/payment-add-edit.component';
import { DepositTypeComponent } from './depositType/deposit-type.component';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { ModeOfPaymentComponent } from './modeOfPayment/mode-of-payment.component';
import { PaymentListComponent } from './paymentList/payment-list.component';
import { ManagerPaymentListComponent } from './managerPaymentList/manager-payment-list.component';
import {  ManagerOnlineRequestListComponent } from './managerOnlineRequestList/manager-online-request-list.component';
import { OfflineRequestComponent } from './offlineRequestList/offline-request.component';
import { OfflineRequestAddEditComponent } from './offlineRequestAddEdit/offline-request-add-edit.component'
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { PassengerInfoComponent } from './passengerInfo/passengerInfo.component';
import { NoRightClickDirective } from './no-right-click.directive';
import { ManagerListComponent } from './managerList/manager-list.component';
import { BookingListComponent } from './bookingList/bookingList.component';
import { TicketIssuanceComponent } from './ticket-issuance/ticket-issuance.component';
import { AirportManageComponent } from './airport-manage/airport-manage.component';
import { OfflineMyBookingTktListComponent } from './offline-my-booking-tkt-list/offline-my-booking-tkt-list.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { RefundTicketOnlineComponent } from './refund-ticket-online/refund-ticket-online.component';
import { HomeDataResolve } from './data-Resolve.resolve';
import { AirlinesMasterComponent } from './airlines-master/airlines-master.component';
import { BookingListSearchCriteriaComponent } from './booking-list-search-criteria/booking-list-search-criteria.component';
import { BackOfficeAccountsComponent } from './back-office-accounts/back-office-accounts.component';
import { ContactUsSubComponent } from './contact-us-sub/contact-us-sub.component';
import { AboutUsSubComponent } from './about-us-sub/about-us-sub.component';
import { FooterComponent } from './footer/footer.component';
import { ImportPnrComponent } from './import-pnr/import-pnr.component';
import { ImportPnrListComponent } from './import-pnr-list/import-pnr-list.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { VoidRevenueManagementComponent } from './void-revenue-management/void-revenue-management.component';
import { RefundRevenueComponent } from './refund-revenue/refund-revenue.component';
import { NavBarMainLoginComponent } from './nav-bar-main-login/nav-bar-main-login.component';
import { ImportRevenueManagementComponent } from './ImportPNRrevenueManagement/importrevenue-management.component'
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsofuseComponent } from './termsofuse/termsofuse.component';
import { CurrencyConversionComponent } from '../app/currency-conversion/currency-conversion.component';
import { BeneficaryDetailsListComponent } from '../app/beneficary-details-list/beneficary-details-list.component';
import { OfflineTicketIssueComponent } from './offlineTicketIssue/offline-ticket-issue.component';
import { PricingandstructureComponent } from './pricingandstructure/pricingandstructure.component';
import { RefundpolicyComponent } from './refundpolicy/refundpolicy.component';
import { ManagersComponent } from './managers/managers.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { CompanyMasterComponent } from './companyMaster/companyMaster.component';
import { DialogModule } from 'primeng/dialog';
import { GroupTicketComponent } from './groupTicket/groupTicket.component';
import { DatePickerModule } from 'primeng/datepicker';
import { BadgeModule } from 'primeng/badge';
import { SelectModule } from 'primeng/select';
import { FilterService } from 'primeng/api';
import { MultiSelectModule } from 'primeng/multiselect';
import { GroupTicketListComponent } from './groupTicketList/groupTicketList.component';
import { FlyDubaiModifyComponent } from './flyDubaiModification/flydubai-modify.component';
import { ToastModule } from 'primeng/toast';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { PanelModule } from 'primeng/panel';
import { SkeletonModule } from 'primeng/skeleton';
import { TooltipModule } from 'primeng/tooltip';

import { AccordionModule } from 'primeng/accordion';
import { ProgressBarModule } from 'primeng/progressbar';
import { TableModule } from 'primeng/table';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { StatementOfAccountComponent } from './statement-of-account/statement-of-account.component'
//20-jan-24
import { OfflineBookingCreateComponent } from './offlineBookingRequest/offlineBookingRequest.component';
import { ConfigService } from './config.service';
import { RateOfExchangeComponent } from './rate-of-exchange/rate-of-exchange.component';
import { RateOfExchangeListComponent } from './rate-of-exchange-list/rate-of-exchange-list.component';
import { FlightResultsNewComponent } from './flightResultsNew/flight-results-new.component';
import { PostAncillaryComponent } from './post-Ancillary/post-ancillary.component';
import { EmiratesModificationComponent } from './emirates-modification/emirates-modification.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ImportPnrEntryComponent } from './import-pnr-entry/import-pnr-entry.component';

import { GroupRevenueReportComponent } from './group-revenue-report/group-revenue-report.component';
import { RevenueReportComponent } from './revenueReport/revenueReport.component';
import { AddSuppliersComponent } from './add-suppliers/add-suppliers.component';
import { ModifyAirItineraryComponent } from './modify-air-itinerary/modify-air-itinerary.component';
import { SpiceModificationComponent } from './SpiceModification/spice-modification.component';
import { AirblueModifyComponent } from './airblue-Modify/airblue-modify.component';

import { GroupTicketForUserNewComponent } from './group-ticket-for-user-new/group-ticket-for-user-new.component';
import { AddGroupTitleComponent } from './add-group-title/add-group-title.component';

import { TravelInsuranceComponent } from './travel-insurance/travel-insurance.component';
import { TravelInsuranceIssuanceComponent } from './travel-insurance-issuance/travel-insurance-issuance.component';
import { TravelInsuranceBookingComponent } from './travel-insurance-booking/travel-insurance-booking.component';
import { DrawerModule } from 'primeng/drawer';


import { TravelInsurancePassengersComponent } from './travel-insurance-passengers/travel-insurance-passengers.component';
import { TravelInsurancePlanResultsComponent } from './travel-insurance-plan-results/travel-insurance-plan-results.component';
import { TravelInsuranceCancellationComponent } from './travel-insurance-cancellation/travel-insurance-cancellation.component';
import { UnitedInsuranceComponent } from './united-insurance/united-insurance.component';
import { UnitedInsuranceHomeComponent } from './united-insurance-home/united-insurance-home.component';
//end
import { InputMaskModule } from 'primeng/inputmask';
import { HomeNewComponent } from './home-new/home-new.component';
import { CarouselModule } from 'primeng/carousel';

import { CmsLoginSliderImagesComponent } from './cms-login-slider-images/cms-login-slider-images.component';
import { FlightSearchNew1Component } from './flight-search-new1/flight-search-new1.component';
import { RegisterComponent } from './register/register.component';
import { RegisterListComponent } from './register/register-list/register-list.component';
import { ForgetPasswordComponent } from './ForgetPassword/forget-password.component';
import { ManagerProficiencyReportComponent } from './manager-proficiency-report/manager-proficiency-report.component';
import { ChartModule } from 'primeng/chart';
import { MasterPassengerInfoComponent } from './master-passenger-info/master-passenger-info.component';
import { MasterPassengerInfoListComponent } from './master-passenger-info-list/master-passenger-info-list.component';
import { TravelPortModificationComponent } from './travel-port-modification/travel-port-modification.component';
import { OfflineSupplierListComponent } from './offline-supplier-list/offline-supplier-list.component';
import { OfflineSupplierComponent } from './offline-supplier/offline-supplier.component';
import { ChatComponent } from './chat/chat.component';
import { OfflineBackOfficeReportComponent } from './offline-back-office-report/offline-back-office-report.component';
import { AuthInterceptor } from './AuthInterceptor';
import { OfflineTicketComponent } from './offline-new/offline-ticket/offline-ticket.component';
import { OfflineBookingComponent } from './offline-new/offline-booking/offline-booking.component';
import { OfflineReissueComponent } from './offline-new/offline-reissue/offline-reissue.component';
import { OfflineRefundComponent } from './offline-new/offline-refund/offline-refund.component';
import { OfflineVoidComponent } from './offline-new/offline-void/offline-void.component';
import { OfflineFlightSearchComponent } from './offline-new/offline-flight-search/offline-flight-search.component';
import { ManagerOfflineRequestListComponent } from './managerOfflineRequestList/manager-offline-request-list.component';
import { OfflineNewComponent } from './offline-new/offline-new.component';
import { AutoCapitalizeDirective } from './offline-new/auto-capitalize.directive';
import { TravelInsuranceRevenueManagementComponent } from './travelInsurance-Revenue-Management/travelInsurance-Revenue-Management.component';
import { CheckboxModule } from "primeng/checkbox";
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ZeusBookedPoliciesComponent } from './zeus-booked-policies/zeus-booked-policies.component';
import { BackOfficeInsuranceReportComponent } from './back-office-insurance-report/back-office-insurance-report.component';
import { PermissionGuard } from './guards/permission.guard';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { UmraOffersComponent } from './umra-offers/umra-offers.component';
import { UmraShortlistedPackageComponent } from './umra-shortlisted-package/umra-shortlisted-package.component';
import { UmraManagerApprovalListComponent } from './umra-manager-approval-list/umra-manager-approval-list.component';
import { UmraReservationUserRequestsListComponent } from './umra-reservation-user-requests-list/umra-reservation-user-requests-list.component';
import { UmraCustomPackagesAddComponent } from './umra-custom-packages-add/umra-custom-packages-add.component';
import { UmraPdfTemplateComponent } from './umra-offers/umra-pdf-template/umra-pdf-template.component';
import { UmraPackageManagementComponent } from './umra-package-management/umra-package-management.component';
import { HotelManagementComponent } from './hotel-management/hotel-management.component';
import { TravelportPccComponent } from './travelport-pcc/travelport-pcc.component';
import { ImportPnrForOfflineIssuedComponent } from './import-pnr-for-offline-issued/import-pnr-for-offline-issued.component';
import { HotelGalleryComponent } from './hotel-gallery/hotel-gallery.component';
import { DataFetchedFromOfflineComponent } from './data-fetched-from-offline/data-fetched-from-offline.component';
import { UmraSupplierManagementComponent } from './umra-supplier-management/umra-supplier-management.component';
import { PackageCardComponent } from './umra-offers/package-card.component';
import { LayoutModule } from '@angular/cdk/layout';

export function initializeApp(configService: ConfigService) {
  return () => firstValueFrom(configService.loadConfigData());
}

